import React from 'react';
import { Box } from '@mui/material';
import { useToast } from './contexts/ToastContext';
import { ToastComponent } from './Toast';

export const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useToast();

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        pointerEvents: 'none',
      }}
    >
      {toasts.map((toast, index) => (
        <Box
          key={toast.id}
          sx={{
            pointerEvents: 'auto',
            transform: `translateY(${index * 8}px)`,
            transition: 'transform 0.3s ease-in-out',
          }}
        >
          <ToastComponent toast={toast} onClose={removeToast} />
        </Box>
      ))}
    </Box>
  );
};
